export default __webpack_public_path__ + "static/Poppins-Italic.87fa2a34.ttf";